module.exports = __webpack_public_path__ + "img/60_5.54fdfdfd.png";